import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
const useStyles = createUseStyles(theme => ({
  root: ({
    height
  }) => ({
    display: 'flex',
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(51, 51, 51, 0.08)',
    border: '2px solid rgba(51, 51, 51, 0.3)',
    overflow: 'hidden',
    padding: theme.SPACING.SMALL,
    height: `${height}px`
  })
}));
export const Placeholder = ({
  classes: classesProp,
  className: classNameProp,
  label,
  height = 60,
  ...rest
}) => {
  const classes = useStyles(undefined, {
    height
  });
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement("span", null, label));
};